import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { compose } from "recompose"
import { connect } from "react-redux"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import Switch from "@material-ui/core/Switch"
import CompanyCard from "../../components/CompanyCard"
import MainAppBar from "../../components/MainAppBar"

const loadPage = params => {
  switch (params.path) {
    case "/setup":
      return 0
    case "/inventory":
      return 1
    case "/checkout":
      return 2
    default:
      return 0
  }
}

class Companies extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      value: 0,
    }
  }
  componentDidUpdate() {
    if (this.state.value !== loadPage(this.props.match)) {
      this.setState({ value: loadPage(this.props.match) })
    }
    return
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }
  openUserDropdown = () => {}
  handleChange = (event, value) => {
    if (value) {
      this.setState({ value })
    }
  }
  handleChangeSwitch = name => event => {
    this.setState({ [name]: event.target.checked })
  }
  render() {
    return (
      <Fragment>
        <MainAppBar />
        <div className="page">
          <main>
            <section className={this.props.classes.companySection}>
              <div className={this.props.classes.companySectionWrapper}>
                {[1, 2, 3].map(i => {
                  return (
                    <div
                      key={i}
                      className={this.props.classes.companyCardWrapper}
                    >
                      <CompanyCard />
                    </div>
                  )
                })}
              </div>
              <Card className={this.props.classes.actionCard}>
                <CardContent>
                  <Typography variant="h6" color="textSecondary">
                    Actions
                  </Typography>
                  <Divider />
                  <Typography variant="subtitle1">Action 1</Typography>
                  <Typography variant="body1">
                    lorem ipsum dolor sit amet, conscteutur adipiscing elit.
                    Duis sit amet faucibus purus.
                  </Typography>
                  <Switch
                    checked={this.state.checkedA}
                    onChange={this.handleChangeSwitch("checkedA")}
                    value="checkedA"
                  />
                </CardContent>
              </Card>
            </section>
          </main>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Companies)
